import React from "react";

const cardIconStyle = {
  display: "block",
  margin: "0 auto 0.7rem auto",
  fontSize: 32,
  color: "#1565c0"
};

const Contact = () => (
  <div style={{ background: "#f5faff", minHeight: "60vh", width: "100%" }}>
    <h1 style={{ color: "#1565c0", marginBottom: "1.2rem", textAlign: "center", paddingTop: "2rem" }}>Contact Us</h1>
    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "2rem", width: "100%", maxWidth: 1200, margin: "0 auto 2.5rem auto" }}>
      {/* Email Card */}
      <div style={{ flex: "1 1 260px", minWidth: 220, background: "#fff", border: "2px solid #1565c0", borderRadius: 14, boxShadow: "0 2px 8px rgba(21,101,192,0.07)", padding: "2rem 1.2rem", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <span style={cardIconStyle}>
          <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M4 6.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6.5M4 6.5 12 13l8-6.5M4 6.5A2 2 0 0 1 6 5h12a2 2 0 0 1 2 1.5" stroke="#1565c0" strokeWidth="2.2"/></svg>
        </span>
        <div style={{ fontSize: "1.08rem", color: "#003c8f" }}>
          <b>Email:</b><br/>Rajeev@namanfinlease.com<br/>nodalofficer@namanfinlease.com
        </div>
      </div>
      {/* Phone Card */}
      <div style={{ flex: "1 1 220px", minWidth: 180, background: "#fff", border: "2px solid #1565c0", borderRadius: 14, boxShadow: "0 2px 8px rgba(21,101,192,0.07)", padding: "2rem 1.2rem", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <span style={cardIconStyle}>
          <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M6.5 4h11A2.5 2.5 0 0 1 20 6.5v11A2.5 2.5 0 0 1 17.5 20h-11A2.5 2.5 0 0 1 4 17.5v-11A2.5 2.5 0 0 1 6.5 4Z" stroke="#1565c0" strokeWidth="2.2"/><path d="M8 8h8M8 12h8M8 16h4" stroke="#1565c0" strokeWidth="2.2"/></svg>
        </span>
        <div style={{ fontSize: "1.08rem", color: "#003c8f" }}>
          <b>Phone:</b><br/>9990831500
        </div>
      </div>
      {/* Address Card */}
      <div style={{ flex: "1 1 320px", minWidth: 220, background: "#fff", border: "2px solid #1565c0", borderRadius: 14, boxShadow: "0 2px 8px rgba(21,101,192,0.07)", padding: "2rem 1.2rem", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <span style={cardIconStyle}>
          <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path d="M12 21s-6-5.686-6-10.286C6 6.477 8.686 4 12 4s6 2.477 6 6.714C18 15.314 12 21 12 21Z" stroke="#1565c0" strokeWidth="2.2"/><circle cx="12" cy="10" r="2.5" stroke="#1565c0" strokeWidth="2.2"/></svg>
        </span>
        <div style={{ fontSize: "1.08rem", color: "#003c8f" }}>
          <b>Address:</b><br/>S-370, Block S, Panchsheel Park South, Panchsheel Park, New Delhi, Delhi 110017
        </div>
      </div>
    </div>
    
    {/* Grievance Section */}
    <div style={{ width: "100%", maxWidth: 1200, margin: "0 auto 2.5rem auto", padding: "0 1rem" }}>
      <div style={{ 
        background: "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)", 
        borderRadius: 16, 
        padding: "clamp(1.5rem, 4vw, 2.5rem)", 
        color: "#fff",
        textAlign: "center",
        boxShadow: "0 8px 32px rgba(21,101,192,0.15)",
        position: "relative",
        overflow: "hidden"
      }}>
        <div style={{
          position: "absolute",
          top: -20,
          right: -20,
          width: "clamp(60px, 8vw, 100px)",
          height: "clamp(60px, 8vw, 100px)",
          background: "rgba(255,255,255,0.1)",
          borderRadius: "50%",
          zIndex: 1
        }}></div>
        <div style={{
          position: "absolute",
          bottom: -30,
          left: -30,
          width: "clamp(50px, 6vw, 80px)",
          height: "clamp(50px, 6vw, 80px)",
          background: "rgba(255,255,255,0.08)",
          borderRadius: "50%",
          zIndex: 1
        }}></div>
        
        <div style={{ position: "relative", zIndex: 2 }}>
          <div style={{ 
            fontSize: "clamp(1.5rem, 4vw, 2rem)", 
            marginBottom: "clamp(0.5rem, 2vw, 1rem)", 
            fontWeight: 700,
            lineHeight: 1.2
          }}>
            🚨 Grievance Redressal
          </div>
          <div style={{ 
            fontSize: "clamp(1rem, 3vw, 1.2rem)", 
            marginBottom: "clamp(1rem, 3vw, 1.5rem)", 
            fontWeight: 600,
            lineHeight: 1.3
          }}>
            For any grievances, please contact us at:
          </div>
          <div style={{ 
            fontSize: "clamp(1.1rem, 3.5vw, 1.4rem)", 
            marginBottom: "0", 
            fontWeight: 700,
            background: "rgba(255,255,255,0.15)",
            padding: "clamp(0.75rem, 2vw, 1rem) clamp(1rem, 4vw, 2rem)",
            borderRadius: 12,
            display: "inline-block",
            wordBreak: "break-word",
            maxWidth: "100%"
          }}>
            <a href="mailto:Grievances@namanfinlease.com" style={{ color: "#fff", textDecoration: "none" }}>
              Grievances@namanfinlease.com
            </a>
          </div>
        </div>
      </div>
    </div>
    
    <div style={{ width: "100%", maxWidth: "100%", margin: 0, borderRadius: 0, overflow: "hidden" }}>
      <iframe
        title="Naman Finlease Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d594.5996985338384!2d77.21886243238974!3d28.5418830717284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce37ec98c1aa7%3A0x2ebe60805720953!2sJurist%20International%20Law%20firm!5e0!3m2!1sen!2sin!4v1752654124986!5m2!1sen!2sin"
        width="100%"
        height="420"
        style={{ border: 0, display: "block", minHeight: 320 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </div>
);

export default Contact; 